import { Navigate, Outlet } from "react-router-dom";
import { useGoogleDrive } from "../../shared/hooks/useGoogleDrive";

// Blocks document/upload pages until the school has connected Google Drive.
const DriveRequiredRoute = () => {
  const driveConnected = useGoogleDrive();
  return driveConnected ? <Outlet /> : <Navigate to="/" replace />;
};

export default DriveRequiredRoute;
